import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, Platform } from '@ionic/angular';
import { advertisement, ServiceService } from 'src/app/service.service';

@Component({
  selector: 'app-cv',
  templateUrl: './cv.page.html',
  styleUrls: ['./cv.page.scss'],
})
export class CvPage implements OnInit {
  public tools:any;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();
  constructor(private loadingController: LoadingController, public services:ServiceService, public alertController: AlertController, private platform: Platform) { }

  async ngOnInit() {
    this.getCatTools();
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(7,1);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  async getCatTools(){
    const loading = await this.loadingController.create({message: 'Espere por favor ...'});
    await loading.present();
    (await this.services.getCatTools()).subscribe(
      (data:any)=>{
        // console.log(data);
        this.tools = data;
      },
      async (error)=>{
        await loading.dismiss();
      },
      async ()=>{
        await loading.dismiss();
      },
    )
  }

  async openWhatsapp(tool:any){
    this.services.openFrame(`${tool.whatsapp}`);
    (await this.services.addPointsUserCV()).subscribe(
      (data:any) => {
        if(data?.win) this.services.showAlert(`Obtuvo + ${data.pointsWin} puntos.`);
      },
      (error) => {
        console.log(error);
      },
    );
  }
}
